import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render financial documents section for FAQ Page
 */
const FinancialDocumentsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="financial-documents-section-component"
    >
      <AccordionV2
        testId="financial-documents"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="2. What kind of financial documents do I need to submit?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 pb-2 pt-6">
          <p>
            You need to submit financial statements of the last two years. For
            businesses that have only been in operation for a year, the
            financial statements required will be for the prior or current year.
            If you do not have a year&apos;s worth of financial statements, then
            the latest management accounts will suffice.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default FinancialDocumentsSection;
